exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/layout/authorised/authorised-side-nav-toggler/authorised-side-nav-toggler.component.css
// module id = ../../../../../src/app/layout/authorised/authorised-side-nav-toggler/authorised-side-nav-toggler.component.css
// module chunks = main